import React from 'react';
import { Link } from 'react-router';
import { getAvatarPlaceholder } from 'utils/avatarUtils';
import './AuthorByline.css';

interface AuthorBylineProps {
  author: {
    id: number;
    username: string;
    avatarUrl: string | null;
  };
  publishedDate?: string;
}

const formatBylineDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

const AuthorByline: React.FC<AuthorBylineProps> = ({ author, publishedDate }) => {
  const placeholder = getAvatarPlaceholder(author.username);

  return (
    <div className="author-byline">
      {author.avatarUrl ? (
        <img
          src={author.avatarUrl}
          alt={author.username}
          className="author-byline-avatar"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
            const next = e.currentTarget.nextElementSibling as HTMLElement;
            if (next) next.style.display = 'flex';
          }}
        />
      ) : null}
      <div
        className="author-byline-avatar author-byline-avatar-placeholder"
        style={{
          backgroundColor: placeholder?.color || '#8409D3',
          display: author.avatarUrl ? 'none' : 'flex',
        }}
      >
        <span className="author-byline-avatar-letter">{placeholder?.letter || '?'}</span>
      </div>
      <div className="author-byline-text">
        <span className="author-byline-label">
          published {publishedDate ? `${formatBylineDate(publishedDate)} ` : ''}by:
        </span>
        <Link to={`/profile/u/${encodeURIComponent(author.username)}`} className="author-byline-link">
          <span className="author-byline-name">{author.username}</span>
        </Link>
      </div>
    </div>
  );
};

export default AuthorByline;
